import './History.scss';
import repeatGrayIcon from '../../assets/icons/repeat-gray.svg';
import repeatWhiteIcon from '../../assets/icons/repeat-white.svg';
import historyIcon from '../../assets/icons/history.svg';
import { useEffect, useRef, useState } from 'react';
import { betApiService } from '../../platform/api/betApiService';
import { IHistoryItem, IHistoryTicket } from '../../platform/interfaces/bet';
import InfiniteScroll from 'react-infinite-scroll-component';
import { betStore, gameStore, roundStore, useTranslation, utilsStore } from '../../platform/stores';
import { RoundStatus } from '../../platform/enums/round-status';
import { observer } from 'mobx-react';
import { betService } from '../../platform/services';
import { isMobile } from '../../platform/utils';

export const History = observer(() => {
  const t = useTranslation();
  const { roundStatus } = roundStore;
  const historyRef = useRef(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const { historyItems, setHistoryItems } = gameStore;

  const loadBets = async () => {
    const response = await betApiService.getBets(page, 10);
    if (response != null) {
      if (page === 1) {
        setHistoryItems(response.list);
      }
      else {
        setHistoryItems(historyItems.concat(response.list));
      }

      setHasMore(response.itemCount !== historyItems.length);
      setPage(page + 1);
    }
  };

  const reBetTicket = (ticket: IHistoryTicket) => {
    if (utilsStore.doNotShowReBetModal) {
      betService.reBet(ticket);
    } else {
      betStore.setTicketToReBet(ticket);
    }
  }

  const reBetRoundTickets = (item: IHistoryItem) => {
    if (roundStatus !== RoundStatus.Started)
      return;

    if (utilsStore.doNotShowReBetModal) {
      betService.reBetRound(item);
    } else {
      betStore.setHistoryItemToReBet(item);
    }
  }

  useEffect(() => {
    loadBets().then();
  }, []);

  return (
    <div className="history-component" ref={historyRef}>
      {
        historyItems.length
          ?
          <InfiniteScroll
            dataLength={historyItems.length}
            next={loadBets}
            hasMore={hasMore}
            height={isMobile() ? 800 : (historyRef?.current as HTMLElement | null)?.offsetHeight}
            loader={<></>}
          >
            {
              historyItems.map((item) =>
                <div className="history-item" key={item.roundId}>
                  <div className={`header flex-center ${roundStatus === RoundStatus.Started ? 'cursor-pointer' : ''}`}
                       onClick={() => reBetRoundTickets(item)}>
                    <div className="text">{t('HISTORY_REPEAT_ALL_BETS')}</div>
                    {
                      roundStatus === RoundStatus.Started
                        ?
                        <img src={repeatWhiteIcon} alt="Repeat icon"/>
                        :
                        <></>
                    }
                  </div>
                  <div className="history-content">
                    <div className="row">
                      <div className="first">{t('HISTORY_ROUND_ID')}</div>
                      <div className="second">{item.roundId}</div>
                    </div>
                    <div className="hr"></div>
                    <div className="row">
                      <div className="first">{t('HISTORY_TOTAL_BETS_COUNT')}</div>
                      <div className="second">{item.totalBetCount}</div>
                    </div>
                    <div className="hr"></div>
                    <div className="row">
                      <div className="first">{t('HISTORY_TOTAL_BETS_AMOUNT')}</div>
                      <div className="second">{item.totalBetAmount}</div>
                    </div>
                    <div className="hr"></div>
                    <div className="row">
                      <div className="first">{t('HISTORY_TOTAL_WIN')}</div>
                      <div className="second">{item.totalWinAmount}</div>
                    </div>
                    <div className="hr"></div>
                    <div className="tickets">
                      {
                        item.tickets.map((ticket) =>
                          <div className="ticket" key={ticket.id}>
                            <div className="row">
                              <div className="first">Ticket Id {ticket.id}</div>
                              <div className="second">
                                {
                                  roundStatus === RoundStatus.Started
                                    ?
                                    <div className="edit-icon flex-center cursor-pointer"
                                         onClick={() => reBetTicket(ticket)}>
                                      <img src={repeatGrayIcon} alt="Repeat icon"/>
                                    </div>
                                    :
                                    <></>
                                }
                              </div>
                            </div>
                            <div className="hr"></div>
                            <div className="numbers">
                              {
                                ticket.numbers.map((number) =>
                                  <div key={'history-' + ticket.id + '-' + number}
                                       className={`number flex-center ${item.numbers.includes(number) ? 'winner' : ''}`}>{number}</div>
                                )
                              }
                            </div>
                            <div className="hr"></div>
                            <div className="row">
                              <div className="first">Bet {ticket.amount}</div>
                              <div className="second">Win {ticket.winAmount}</div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
            }
          </InfiniteScroll>
          :
          <div className="empty-history flex-center">
            <div>
              <div className="flex-center">
                <img src={historyIcon} alt="History icon"/>
              </div>
              <div className="title">{t('HISTORY')}</div>
              <div className="description">{t('HISTORY_YOU_DO_NOT_HAVE_HISTORY')}</div>
            </div>
          </div>
      }
    </div>
  );
});
